require("../vendor/chosen-js/chosen.jquery.js");

interface JQuery {
  chosenSelect: { (): void; defaults?: any };
}

$.fn.chosenSelect = function () {
  this.each(function () {
    var $elem = $(this) as JQuery<HTMLSelectElement>;
    var _defaults = $.fn.chosenSelect.defaults;

    if (!$elem.is("select")) {
      throw new Error(
        "This plugin expects the DOM object using it to be of type 'SELECT'",
      );
    } else {
      var config = $elem.data("chosen");

      if (!config || !$.isPlainObject(config["config"])) {
        config = {};
      } else {
        config = config["config"];
      }

      config = $.extend(true, {}, _defaults, config);

      $elem.chosen(config);

      // Removing the automatically embedded 'style' attribute to allow
      // our external, customised CSS file apply desired styling
      $(".chosen-container *")
        .filter(function () {
          return (
            !$(this).is('li.search-field input[type="text"]') &&
            !$(this).is(".chosen-container")
          );
        })
        .removeAttr("style");

      const facetParent = $elem.parents(".filter-selector");
      const addToMultiselectButton = facetParent.find("button.add-to-multiselect");
      if (addToMultiselectButton.length) {
        addToMultiselectButton.on('click', function() {
          const addToMultiselectDropdown = facetParent.find("select.add-to-multiselect");
          addValueToMultiselect($elem, addToMultiselectDropdown.val() as string);
          addToMultiselectDropdown.val('');
        });
      }
      const listOfSelectedOptions = facetParent.find('ul.multiselect-chosen-options');
      const summary = facetParent.find('.multiselect-summary');
      if (listOfSelectedOptions.length) {
        updateSelectedOptionsList($elem, listOfSelectedOptions, summary);
        $elem.on("chosen:updated", function(event, data) {
          updateSelectedOptionsList($elem, listOfSelectedOptions, summary);
        });
      }

      $elem.on("chosen:clear", function(){
        $elem.val([]).trigger("change").trigger("chosen:updated");
      })
    }
  });
};

function clearChosenItem(){
  if($('.chosen-single span').length > 0){
    $('.chosen-single span').text('Select collection');
    $('.chosen-single span').val('').trigger("change").trigger("chosen:updated");
  }
}

function updateSelectedOptionsList(selectElement: JQuery<HTMLSelectElement>, list: JQuery, summary: JQuery) {
  const selectedValues = selectElement.val() as string[];
  if (!Array.isArray(selectedValues)){
    summary.text('');
    clearChosenItem();
    return; // Nothing selected or not multi-select
  }
  else{
    list.text('');
  }
  selectedValues.forEach(function(selectedValue) {
    const option = selectElement.find(`option[value="${selectedValue}"]`) as JQuery<HTMLOptionElement>
    option.each(function(i, opt) {
      const selectedOptionLi: JQuery<HTMLLIElement> = $(`<li class="search-choice"><span>${opt.text}</span><button class="search-choice-close" aria-label="remove tag"></button></li>`);
      selectedOptionLi.find('.search-choice-close').on('click', function() {
        removeValueFromMultiselect(selectElement, opt.value);
      });
      list.append(selectedOptionLi);
    });
  });
  summary.text(selectedValues.length ? `(${selectedValues.length} selected)` : '');
}

function removeValueFromMultiselect(selectElement: JQuery<HTMLSelectElement>, valueToRemove: string) {
  const selectedValues = selectElement.val() as string[];
  selectElement.val(selectedValues.filter(item => item !== valueToRemove)).trigger("change").trigger("chosen:updated");
}

function addValueToMultiselect(selectElement: JQuery<HTMLSelectElement>, valueToAdd: string) {
  if (!valueToAdd) {
    return;
  }
  const selectedValues = selectElement.val() as string[];
  selectElement.val([...selectedValues, valueToAdd]).trigger('change').trigger('chosen:updated');
  clearChosenItem();
}

function isInGrantSectionPage() {
  return $("#grant-sections-page").length > 0;
}

$.fn.chosenSelect.defaults = {
  width: widthValue(),
  allow_single_deselect: true,
  disable_search_threshold: "5"
};

function widthValue() {
  if (isInGrantSectionPage()) {
    return "75%";
  }
   else {
    return "50%";
  }
}

function initialiseSelectAllPayments() {
  const selectAllCheckbox = document.getElementById("select-all-payments") as HTMLInputElement | null;
  const form = selectAllCheckbox?.closest("form") as HTMLFormElement | null;
  const hiddenInputContainer = document.getElementById("hidden-input-container");

  if (!selectAllCheckbox || !form || !hiddenInputContainer) {
    return;
  }

  if (form.dataset.selectAllPaymentsInitialised === "true") {
    return;
  }

  form.dataset.selectAllPaymentsInitialised = "true";


  const clearMultiplePaymentSessionStorage = () => {
    sessionStorage.removeItem("multiplePaymentsSelectedReferences");
    sessionStorage.removeItem("multiplePaymentsDeselectedReferences");
    sessionStorage.removeItem("multiplePaymentsSelectAllActive");
  };


  const clearStorageIfNewLoginSession = () => {
    const currentLoginSessionMarker = hiddenInputContainer.dataset.loginSessionMarker;

    if (!currentLoginSessionMarker) {
      return;
    }

    const storedLoginSessionMarker = sessionStorage.getItem("multiplePaymentsLoginSessionMarker");

    if (storedLoginSessionMarker && storedLoginSessionMarker !== currentLoginSessionMarker) {
      clearMultiplePaymentSessionStorage();
    }

    sessionStorage.setItem("multiplePaymentsLoginSessionMarker", currentLoginSessionMarker);
  };

  clearStorageIfNewLoginSession();



  const rowCheckboxes = Array.from(
      document.querySelectorAll<HTMLInputElement>(".payment-selection-checkbox")
  );

  const selectedPaymentsStorageKey = "multiplePaymentsSelectedReferences";
  const deselectedPaymentsStorageKey = "multiplePaymentsDeselectedReferences";
  const selectAllPaymentsStorageKey = "multiplePaymentsSelectAllActive";

  const uniqueValues = (values: string[]): string[] => {
    return Array.from(new Set(values.filter((value) => value !== "")));
  };

  const getStoredList = (key: string): string[] => {
    const storedValue = sessionStorage.getItem(key);

    if (!storedValue) {
      return [];
    }

    try {
      const parsedValue = JSON.parse(storedValue);

      if (!Array.isArray(parsedValue)) {
        return [];
      }

      return uniqueValues(parsedValue.map(String));
    } catch {
      return [];
    }
  };

  const setStoredList = (key: string, values: string[]) => {
    sessionStorage.setItem(key, JSON.stringify(uniqueValues(values)));
  };

  const isSelectAllActive = (): boolean => {
    return sessionStorage.getItem(selectAllPaymentsStorageKey) === "true";
  };

  const setSelectAllActive = (active: boolean) => {
    sessionStorage.setItem(selectAllPaymentsStorageKey, String(active));
  };

  const addValueToStoredList = (key: string, value: string) => {
    const values = getStoredList(key);
    setStoredList(key, [...values, value]);
  };

  const removeValueFromStoredList = (key: string, value: string) => {
    const values = getStoredList(key).filter((storedValue) => storedValue !== value);
    setStoredList(key, values);
  };

  const clearSelectionStorage = () => {
    setStoredList(selectedPaymentsStorageKey, []);
    setStoredList(deselectedPaymentsStorageKey, []);
  };

  const updateSelectAllCheckboxState = () => {
    const selectAllActive = isSelectAllActive();
    const deselectedPaymentReferences = getStoredList(deselectedPaymentsStorageKey);

    const checkedCount = rowCheckboxes.filter((checkbox) => checkbox.checked).length;
    const hasCurrentPageSelections = checkedCount > 0;
    const hasGlobalDeselections = deselectedPaymentReferences.length > 0;

    /*
      If select-all is active and nothing has been deselected,
      show the master checkbox as checked.

      If select-all is active but at least one payment was deselected
      on any page, show it as indeterminate across all pages.
    */
    selectAllCheckbox.checked = selectAllActive && !hasGlobalDeselections;

    selectAllCheckbox.indeterminate =
        (selectAllActive && hasGlobalDeselections) ||
        (!selectAllActive &&
            hasCurrentPageSelections &&
            checkedCount < rowCheckboxes.length);
  };

  const applyStoredSelectionToCurrentPage = () => {
    const selectAllActive = isSelectAllActive();
    const selectedPaymentReferences = new Set(getStoredList(selectedPaymentsStorageKey));
    const deselectedPaymentReferences = new Set(getStoredList(deselectedPaymentsStorageKey));

    rowCheckboxes.forEach((checkbox) => {
      if (selectAllActive) {
        checkbox.checked = !deselectedPaymentReferences.has(checkbox.value);
      } else {
        checkbox.checked = selectedPaymentReferences.has(checkbox.value);
      }
    });

    updateSelectAllCheckboxState();
  };

  selectAllCheckbox.addEventListener("change", () => {
    const checked = selectAllCheckbox.checked;

    if (checked) {
      /*
        Select all means all payments across all pages are selected.
        We do not need to store every selected payment reference here.
        We only store deselections later as exceptions.
      */
      setSelectAllActive(true);
      clearSelectionStorage();

      rowCheckboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });
    } else {
      /*
        Deselect all means everything across all pages is cleared.
      */
      setSelectAllActive(false);
      clearSelectionStorage();

      rowCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    }

    selectAllCheckbox.indeterminate = false;
    updateSelectAllCheckboxState();
  });

  rowCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      if (isSelectAllActive()) {
        /*
          In global select-all mode:
          - unchecked row becomes an exception
          - checked row removes the exception
        */
        if (checkbox.checked) {
          removeValueFromStoredList(deselectedPaymentsStorageKey, checkbox.value);
        } else {
          addValueToStoredList(deselectedPaymentsStorageKey, checkbox.value);
        }
      } else {
        /*
          Normal manual selection mode:
          only explicitly checked payments are stored.
        */
        if (checkbox.checked) {
          addValueToStoredList(selectedPaymentsStorageKey, checkbox.value);
        } else {
          removeValueFromStoredList(selectedPaymentsStorageKey, checkbox.value);
        }
      }

      updateSelectAllCheckboxState();
    });
  });

  form.addEventListener("submit", () => {
    hiddenInputContainer
        .querySelectorAll<HTMLInputElement>(
            "input.selected-payment-reference-hidden, input.deselected-payment-reference-hidden, input.select-all-payments-hidden"
        )
        .forEach((input) => input.remove());

    const selectAllActive = isSelectAllActive();

    const selectAllHiddenInput = document.createElement("input");
    selectAllHiddenInput.type = "hidden";
    selectAllHiddenInput.name = "selectAllPayments";
    selectAllHiddenInput.value = String(selectAllActive);
    selectAllHiddenInput.className = "select-all-payments-hidden";
    hiddenInputContainer.appendChild(selectAllHiddenInput);

    if (selectAllActive) {
      const deselectedPaymentReferences = uniqueValues(
          getStoredList(deselectedPaymentsStorageKey)
      );

      setStoredList(deselectedPaymentsStorageKey, deselectedPaymentReferences);

      deselectedPaymentReferences.forEach((paymentReference) => {
        const hiddenInput = document.createElement("input");

        hiddenInput.type = "hidden";
        hiddenInput.name = "deselectedPaymentReferences";
        hiddenInput.value = paymentReference;
        hiddenInput.className = "deselected-payment-reference-hidden";

        hiddenInputContainer.appendChild(hiddenInput);
      });
    } else {
      const selectedPaymentReferences = uniqueValues(
          getStoredList(selectedPaymentsStorageKey)
      );

      setStoredList(selectedPaymentsStorageKey, selectedPaymentReferences);

      selectedPaymentReferences.forEach((paymentReference) => {
        const hiddenInput = document.createElement("input");

        hiddenInput.type = "hidden";
        hiddenInput.name = "selectedPaymentReferences";
        hiddenInput.value = paymentReference;
        hiddenInput.className = "selected-payment-reference-hidden";

        hiddenInputContainer.appendChild(hiddenInput);
      });
    }
  });

  applyStoredSelectionToCurrentPage();
}

$(function () {
  initialiseSelectAllPayments();
});